import React, { useState } from 'react';
import { toast } from 'sonner';
type InquiryType = 'Board Governance' | 'Executive Strategy' | 'Advisory' | 'Speaking';
const inquiryTypes: InquiryType[] = ['Board Governance', 'Executive Strategy', 'Advisory', 'Speaking'];
export function ContactForm() {
  const [name, setName] = useState('');
  const [organization, setOrganization] = useState('');
  const [email, setEmail] = useState('');
  const [inquiryType, setInquiryType] = useState<InquiryType>('Board Governance');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!name || !email || !message) {
      toast.error('Please complete all required fields.');
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success('Message sent to gerson.eli@gmail.com', {
        description: "Thank you for reaching out, you'll hear back within 1 to 2 business days."
      });
      setName('');
      setOrganization('');
      setEmail('');
      setMessage('');
      setInquiryType('Board Governance');
    }, 700);
  };
  return <form onSubmit={handleSubmit} className="rounded-xl border border-white/10 bg-navy-light p-8 lg:p-10" data-id="element-130" data-mp="1k0cyc6l1t22b">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-131" data-mp="1f34k2h30ti6c">
        <div className="sm:col-span-1" data-id="element-132" data-mp="2cpjz7c7z63qq">
          <label htmlFor="name" className="text-sm font-medium text-slate-200" data-id="element-133" data-mp="2coio57qylh90">
            Name
          </label>
          <input id="name" type="text" required value={name} onChange={e => setName(e.target.value)} className="mt-2 w-full rounded-md border border-white/15 bg-navy px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:border-brandgreen focus:outline-none focus:ring-1 focus:ring-brandgreen" placeholder="Jane Doe" data-id="element-134" data-mp="27rig4raju4f9" />
        </div>
        <div className="sm:col-span-1" data-id="element-135" data-mp="3ajctpkzjwl48">
          <label htmlFor="organization" className="text-sm font-medium text-slate-200" data-id="element-136" data-mp="3ake4rpgkh7ly">
            Organization
          </label>
          <input id="organization" type="text" value={organization} onChange={e => setOrganization(e.target.value)} className="mt-2 w-full rounded-md border border-white/15 bg-navy px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:border-brandgreen focus:outline-none focus:ring-1 focus:ring-brandgreen" placeholder="Company or organization" data-id="element-137" data-mp="3eiu2ooe6s0e5" />
        </div>
        <div className="sm:col-span-1" data-id="element-138" data-mp="2hvgr5znavyzj">
          <label htmlFor="email" className="text-sm font-medium text-slate-200" data-id="element-139" data-mp="2hwid4z5uu5w1">
            Email
          </label>
          <input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2 w-full rounded-md border border-white/15 bg-navy px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:border-brandgreen focus:outline-none focus:ring-1 focus:ring-brandgreen" placeholder="you@company.com" data-id="element-140" data-mp="2mre4ry76ir8m" />
        </div>
        <div className="sm:col-span-1" data-id="element-141" data-mp="23905brwzwv5e">
          <label htmlFor="inquiryType" className="text-sm font-medium text-slate-200" data-id="element-142" data-mp="235vsk65gsr34">
            Subject / Inquiry Type
          </label>
          <select id="inquiryType" value={inquiryType} onChange={e => setInquiryType(e.target.value as InquiryType)} className="mt-2 w-full rounded-md border border-white/15 bg-navy px-4 py-2.5 text-sm text-white focus:border-brandgreen focus:outline-none focus:ring-1 focus:ring-brandgreen" data-id="element-143" data-mp="2c851wsozyeex">
            {inquiryTypes.map(type => <option key={type} value={type} data-id="element-144" data-mp="2vw4febay3zo1">
                {type}
              </option>)}
          </select>
        </div>
        <div className="sm:col-span-2" data-id="element-145" data-mp="2qyuk4f0vktsa">
          <label htmlFor="message" className="text-sm font-medium text-slate-200" data-id="element-146" data-mp="oavww0oohc8f">
            Message
          </label>
          <textarea id="message" required rows={5} value={message} onChange={e => setMessage(e.target.value)} className="mt-2 w-full resize-none rounded-md border border-white/15 bg-navy px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:border-brandgreen focus:outline-none focus:ring-1 focus:ring-brandgreen" placeholder="Share the context of your inquiry..." data-id="element-147" data-mp="t9gwpz00ptwc" />
        </div>
      </div>

      <button type="submit" disabled={isSubmitting} className="mt-7 inline-flex w-full items-center justify-center rounded-md bg-brandgreen px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brandgreen-dark disabled:opacity-60 sm:w-auto" data-id="element-148" data-mp="f9ob2i3cm3v8">
        {isSubmitting ? 'Sending...' : 'Send Message'}
      </button>
    </form>;
}